import axios from "axios";

import { API_ROOT, WS_ROOT } from "./config/apiConfig";

/**
 * Legacy ranger/trooper service module.
 *
 * The base URL is resolved through ``config/apiConfig`` — set
 * ``REACT_APP_API_ROOT`` / ``REACT_APP_WS_ROOT`` in ``.env`` to point
 * dev / staging / prod builds at different servers.
 */
export const ENDPOINTS = {
  BASE_URL: API_ROOT + "/",
  BASE_WS_URL: WS_ROOT + "/",
  USER_LOGIN: "ranger/rangerLogin/",
  GET_IN_STREAM: "getIn/stream/",
  GET_OUT_STREAM: "getOut/stream/",
  ANALYTICS: "analytics/stream/",
  CHECK_BOOKING: "api/trooper/checkBooking",
};

export const LoginPage = async (body) => {
  return await axios.post(ENDPOINTS.BASE_URL + ENDPOINTS.USER_LOGIN, body, {
    timeout: 3 * 60 * 1000,
  });
};

export const checkBooking = async (body) => {
  return await axios.post(ENDPOINTS.BASE_URL + ENDPOINTS.CHECK_BOOKING, body, {
    timeout: 3 * 60 * 1000,
  });
};
